module.exports = new __parcel__URL__("80384_sq.d471bac4.jpg").toString();